import * as React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import { visuallyHidden } from "@mui/utils";
import { useNavigate } from "react-router-dom";
import { HelperContext } from "../../Context/HelperContext";

export default function FranchiseTable({ row, sub }) {
  const { statusCase } = React.useContext(HelperContext);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([0]);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const navigate = useNavigate();
  function descendingComparator(a, b, orderBy) {
    if (typeof a[orderBy] == "string" && typeof b[orderBy]) {
      return b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase() ? -1 : 1;
    } else {
      return b[orderBy] < a[orderBy] ? -1 : 1;
    }
  }
  React.useEffect(() => {
    setRows(row);
    setOrderBy("StartDate"); // Set the default order by the StartDate
    setOrder("asc"); // Set default order direction
  }, [row]);

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  React.useEffect(() => {
    setRows(row);
  }, [row]);
  // HeadTitles ----------------------------------------------
  const headCells = [
    {
      id: "Id",
      numeric: false,
      disablePadding: true,
      label: "ID",
    },
    {
      id: "EventName",
      numeric: true,
      disablePadding: false,
      label: "NAME",
    },
    {
      id: "CostperDelegate",
      numeric: true,
      disablePadding: false,
      label: "COST / DELEGATE	",
    },
    {
      id: "EventCost",
      numeric: true,
      disablePadding: false,
      label: "Event Cost",
    },
    {
      id: "StartDate",
      numeric: true,
      disablePadding: false,
      label: "Start Date",
    },
    {
      id: "CreatedAt",
      numeric: true,
      disablePadding: false,
      label: "Created At",
    },
    {
      id: "Status",
      numeric: true,
      disablePadding: false,
      label: "Status",
    },
  ];

  // Sorting---Head /--------------------------------
  function EnhancedTableHead(props) {
    const {
      // onSelectAllClick,
      order,
      orderBy,
      // numSelected,
      // rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              style={{ fontSize: "16px" }}
              key={headCell.id}
              align={headCell.numeric ? "center" : "center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const parseDate = (dateString) => {
  //   console.log(dateString);
  //   let date = `${dateString}`;
  //   const [day, month, year] = date.split("/");
  //   return new Date(`${year}-${month}-${day}`);
  // };

  // const statusCase = (start, end) => {
  //   // const currentDate = new Date();
  //   // currentDate.setHours(0, 0, 0, 0);

  //   // // Parse the start and end dates
  //   // start = parseDate(start);
  //   // end = parseDate(end);
  //   // start.setHours(0, 0, 0, 0);
  //   // end.setHours(23, 59, 59, 999);
  //   console.log(start,"start");
  //   console.log(end,"end");

  //   // // Compare dates and return status accordingly
  //   // if (currentDate < start) {
  //   //   return { status: "Pending", color: "bg-warning" };
  //   // } else if ((currentDate >= start && currentDate <= end ) || currentDate == start) {
  //   //   return { status: "Started", color: "bg-info" };
  //   // } else {
  //   //   return { status: "Ended", color: "bg-danger" };
  //   // }
  // };

  // const statusCase = (start, end) => {
  //   const currentDate = new Date();
  //   // start = new Date(start);
  //   // end = new Date(end);
  //   console.log(start, "start");
  //   console.log(end, "end");

  //   start = parseDate(start);
  //   end = parseDate(end);

  //   if (currentDate < start) {
  //     return { status: "Pending", color: "bg-warning" };
  //   } else if (
  //     (currentDate >= start && currentDate <= end) ||
  //     currentDate == start
  //   ) {
  //     return { status: "Started", color: "bg-info" };
  //   } else {
  //     return { status: "Ended", color: "bg-danger" };
  //   }
  // };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.ID);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    let newSelected = [];
    const selectedIndex = selected.indexOf(id);
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    // In ChecKbOX /--------------------------------------------------------------------
    //
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),

    [order, orderBy, page, rowsPerPage]
  );

  function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Typography
            sx={{ flex: "1 1 100%" }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography
            sx={{ flex: "0 1 100%" }}
            variant="h2"
            id="tableTitle"
            component="div"
          >
            {/* //// */}
            {/* <SearchFormik rows={rows} setRows={setRows} /> */}
          </Typography>
        )}

        {numSelected > 0 && (
          <Tooltip title="Delete">
            {/* <IconButton onClick={() => DeleteField(selected)}>
              <DeleteIcon />
            </IconButton> */}
          </Tooltip>
        )}
      </Toolbar>
    );
  }
  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  // body ----------------
  return (
    <Paper sx={{ width: "100%", mb: 0 }} className="BasicTableParent">
      <div className=" d-flex align-items-center gap-2 p-3 d-flex justify-content-end ">
        <span className="d-flex gap-2 align-items-center">
          <span className="fs-6 exportExcel">
            {/* <ExportDropDown rows={rows} sub={sub}/> */}
          </span>
        </span>
        {/* the following line should be activated but it has an error */}
        {/* <ImportExcel /> */}
        {/* <SearchText list={row} /> */}
      </div>
      <EnhancedTableToolbar numSelected={selected.length} />
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-labelledby="tableTitle">
          <EnhancedTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {visibleRows.map((row, index) => {
             
              if (!row || !row.ID || !row.Id) return null; // Ensure row and necessary properties exist
              
              const isItemSelected = isSelected(row.ID);
              const labelId = `enhanced-table-checkbox-${index}`;
              return (
                <TableRow
                  hover
                  onClick={(event) => handleClick(event, row.ID)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={`${row.ID}-${index}`}
                  selected={isItemSelected}
                  sx={{ cursor: "pointer" }}
                >
                  {/* <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      checked={isItemSelected}
                      inputProps={{
                        "aria-labelledby": labelId,
                      }}
                    />
                  </TableCell> */}

                  <TableCell
                    component="th"
                    id={labelId}
                    scope="row"
                    padding="none"
                    align="center"
                    onClick={() =>
                      navigate(`/app/subscribers/${row.Id}/${row.ID}`)
                    }
                  >
                    <span className="text-blueColor text-base font-normal">
                      {row.Id}
                    </span>
                  </TableCell>
                  <TableCell
                    onClick={() =>
                      navigate(`/app/subscribers/${row.Id}/${row.ID}`)
                    }
                    align="center"
                  >
                    <span className="text-blueColor text-base font-normal">
                      {row.eventName}
                    </span>
                  </TableCell>
                  <TableCell
                    onClick={() =>
                      navigate(`/app/subscribers/${row.Id}/${row.ID}`)
                    }
                    align="center"
                  >
                    <span className="text-blueColor text-base font-normal">
                      {row.CostperDelegate}
                    </span>
                  </TableCell>
                  <TableCell
                    onClick={() =>
                      navigate(`/app/subscribers/${row.Id}/${row.ID}`)
                    }
                    align="center"
                  >
                    <span className="text-blueColor text-base font-normal">
                      {row.eventCost}
                    </span>
                  </TableCell>
                  <TableCell
                    onClick={() =>
                      navigate(`/app/subscribers/${row.Id}/${row.ID}`)
                    }
                    align="center"
                  >
                    <span className="text-blueColor text-base font-normal">
                      {row.eventDate}
                    </span>
                  </TableCell>
                  <TableCell
                    onClick={() =>
                      navigate(`/app/subscribers/${row.Id}/${row.ID}`)
                    }
                    align="center"
                  >
                    <span className="text-blueColor text-base font-normal">
                      {row.CreatedAt}
                    </span>
                  </TableCell>
                  <TableCell
                    onClick={() =>
                      navigate(`/app/subscribers/${row.Id}/${row.ID}`)
                    }
                    align="center"
                  >
                    <span
                      className={`${
                        statusCase(row.eventDate, row.endDate).color
                      } text-white p-2 rounded `}
                    >
                      {statusCase(row.eventDate, row.endDate).status}
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
              <TableRow>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
